import type { RealTimeMaterialPricingModalState } from './reducer';

export const types = {
  ACTIVE_VENDOR_MATERIAL_PRICING_PLAN_SET:
    'common/modals/realTimeMaterialPricingModal/ACTIVE_VENDOR_MATERIAL_PRICING_PLAN_SET',
  PANEL_STATE_SET: 'common/drawers/tkMaterialQuoteDrawer/PANEL_STATE_SET',
  SELECTED_PRODUCT_CODE_SET:
    'common/modals/realTimeMaterialPricingModal/SELECTED_PRODUCT_CODE_SET',
  REAL_TIME_MATERIAL_PRICING_MODAL_OPEN:
    'common/modals/realTimeMaterialPricingModal/REAL_TIME_MATERIAL_PRICING_MODAL_OPEN',
  REAL_TIME_MATERIAL_PRICING_MODAL_CLOSE:
    'common/modals/realTimeMaterialPricingModal/REAL_TIME_MATERIAL_PRICING_MODAL_CLOSE',
  SELECT_MATERIALS:
    'common/modals/realTimeMaterialPricingModal/SELECT_MATERIALS',
} as const;

export const realTimeMaterialPricingModal = {
  open: ({
    allowRequoting,
    componentId,
    focusedComponentQuantityId,
    operationId,
    source,
    vendorMaterialPricingPlanId,
  }: Pick<
    RealTimeMaterialPricingModalState,
    | 'allowRequoting'
    | 'componentId'
    | 'focusedComponentQuantityId'
    | 'operationId'
    | 'source'
  > & {
    vendorMaterialPricingPlanId: RealTimeMaterialPricingModalState['activeVendorMaterialPricingPlanId'];
  }) => ({
    type: types.REAL_TIME_MATERIAL_PRICING_MODAL_OPEN,
    payload: {
      allowRequoting,
      componentId,
      focusedComponentQuantityId,
      operationId,
      source,
      vendorMaterialPricingPlanId,
    },
  }),
  close: () => ({
    type: types.REAL_TIME_MATERIAL_PRICING_MODAL_CLOSE,
  }),
};

export const activeVendorMaterialPricingPlan = {
  set: ({
    activeVendorMaterialPricingPlanId,
  }: Pick<
    RealTimeMaterialPricingModalState,
    'activeVendorMaterialPricingPlanId'
  >) => ({
    type: types.ACTIVE_VENDOR_MATERIAL_PRICING_PLAN_SET,
    payload: { activeVendorMaterialPricingPlanId },
  }),
};

export const panelState = {
  set: ({
    panelState,
  }: Pick<RealTimeMaterialPricingModalState, 'panelState'>) => ({
    type: types.PANEL_STATE_SET,
    payload: { panelState },
  }),
};

export const selectMaterials = {
  put: ({
    materialSelections,
  }: Pick<RealTimeMaterialPricingModalState, 'materialSelections'>) => ({
    type: types.SELECT_MATERIALS,
    payload: { materialSelections },
  }),
};
